import { render, staticRenderFns } from "./PatientCode.vue?vue&type=template&id=b9cc1354&scoped=true"
import script from "./PatientCode.vue?vue&type=script&lang=js"
export * from "./PatientCode.vue?vue&type=script&lang=js"
import style0 from "./PatientCode.vue?vue&type=style&index=0&id=b9cc1354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cc1354",
  null
  
)

export default component.exports